import { Injectable } from '@angular/core';
import { HttpClient, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { ApiConfiguration } from '@/core/api/api-configuration';
import { BaseService } from '@/core/api/base-service';
import { environment } from '@env/environment';
import { SICOM_PATHS } from 'src/sicom-paths';
import { ReportRequerimentoUnicoMedicoRequest, ReportRequerimentoUnicoMedicoResponse, ReportJobCreatedResponse, ReportJobStatusResponse } from './requerimento-unico-medico.model';

/** Cliente HTTP do relatório assíncrono Requerimento Único (Médico). */
@Injectable({ providedIn: 'root' })
export class RequerimentoUnicoMedicoService extends BaseService {
    readonly PATH = SICOM_PATHS.registro.medico.reports.requerimentoUnicoMedico;

    constructor(config: ApiConfiguration, http: HttpClient) {
        super(config, http, environment.apis.apiSicom);
    }

    exportarPdf(request: ReportRequerimentoUnicoMedicoRequest): Observable<HttpResponse<ReportRequerimentoUnicoMedicoResponse | ReportJobCreatedResponse>> {
        return this.http.post<ReportRequerimentoUnicoMedicoResponse | ReportJobCreatedResponse>(`${this.PATH}/exportar-pdf`, request, { observe: 'response' });
    }

    iniciarGeracaoAssincrona(request: ReportRequerimentoUnicoMedicoRequest): Observable<ReportJobCreatedResponse> {
        return this.http.post<ReportJobCreatedResponse>(`${this.PATH}/exportar-pdf-async`, request);
    }

    consultarStatus(jobId: string): Observable<ReportJobStatusResponse> {
        return this.http.get<ReportJobStatusResponse>(`${this.PATH}/job/${jobId}/status`);
    }

    baixarPdf(jobId: string): Observable<ArrayBuffer> {
        return this.http.get(`${this.PATH}/job/${jobId}/download`, { responseType: 'arraybuffer' });
    }
}
